<template>
    <div class="content-container">
        <div class="with-animation image" v-bind:class="[imageAnimation]" :style="imageContainerStyle" />
        <div v-if="!scrolling" class="content-text">
            <div>
                <div class="previous-btn-container">
                    <img :class="{none: this.page.id === 0}" src="../assets/icons/arrow_up.png" @click="clickPrevious">
                </div>
                <div class="text-container with-animation" v-bind:class="[textAnimation]">
                    <h1 class="header">{{ page.title }}</h1>
                    <p v-if="page.subtitle !== false" class="subtitle">{{ page.subtitle }}</p>
                    <p> {{ page.text }} </p>
                    <slot/>
                </div>
                <div class="next-btn-container">
                    <img :class="{none: showNextBtn}" src="../assets/icons/arrow_down.png" @click="clickNext">
                </div>
            </div>
        </div>
        <div v-else class="content-text scrolling with-animation" v-bind:class="[textAnimation]">
            <div>
                <h1 class="header" v-html="page.title"/>
                <div class="content-text-scrolling" :style="{bottom: contentBelowHeight}">
                    <p v-if="page.subtitle !== false" class="subtitle">{{ page.subtitle }}</p>
                    <p v-html="page.text"></p>
                    <slot v-if="!contentBelowHeight"/>
                </div>
                <div class="content-below">
                    <slot v-if="contentBelowHeight"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PageContent",
        props: {
            content: {
                default: () => ({}),
                type: Object
            },
            scrolling: {
                default: false,
                type: Boolean
            },
            imgAnimation: {
                default: 'slidedown',
                type: Boolean
            },
            txtAnimation: {
                default: 'slideright',
                type: Boolean
            },
            imgBgSize: {
                default: 'contain',
                type: String
            },
            contentBelowHeight: {
                default: false
            }
        },
        data() {
            return {
                doTextAnimation: true,
                imgSlideDown: true,
                mainRoute: ''
            }
        },
        computed: {
            imageAnimation() {
                return this.imgSlideDown ? this.imgAnimation : ''
            },
            textAnimation() {
                return this.doTextAnimation ? this.txtAnimation : ''
            },
            page() {
                this.showImage = false
                let route = this.$route.fullPath
                let routes = route.split('/')
                var filtered = routes.filter(el => el != "" )
                let content = this.content
                filtered.forEach(r => {
                    if (filtered.length === 1) content = content[r][r]
                    else content = content[r]
                })

                if(!this.landingview) this.animateContent(true)

                return content
            },
            actualRoute() {
                let routes = this.$route.fullPath.split('/')
                return routes[routes.length-1]
            },
            imageUrl() {
                if (this.page) return require("@/assets/" + this.page.imageUrl)
                else return ""
            },
            showNextBtn() {
                if (this.content !== {}) {
                    let show = this.page.id === Object.keys(this.content[this.mainRoute]).length-1
                    return show
                }
            },
            imageContainerStyle() {
                return {
                    'background-image': `url(${this.imageUrl})`,
                    'background-size': this.imgBgSize,
                    'background-repeat': 'no-repeat',
                    'background-position': '50%'
                }
            },
            showLandingview() {
                return this.$store.state.isLandingView
            }
        },
        watch: {
            showLandingview() {
              this.animateContent()
          }
        },
        mounted() {
            this.mainRoute = Object.keys(this.content)[0]
            let pageObject = this.content[this.mainRoute]
            let count = 0
            for (let key in pageObject) {
                if (pageObject.hasOwnProperty(key)) {
                    pageObject[key].id = count++
                }
            }
            if (!this.showLandingview) this.animateContent()
        },
        methods: {
            animateContent(onlyText) {
                if (!this.showLandingview) {
                    this.doTextAnimation = false
                    if (!onlyText) this.imgSlideDown = false
                    setTimeout(() => {
                        this.doTextAnimation = true
                        if (!onlyText) this.imgSlideDown = true
                    }, 10)
                }

            },
            clickNext() {
                let pages = this.content[this.mainRoute]
                let next = ''
                for (let key in pages) {
                        if (pages[key].id === this.page.id+1) next = key
                }
                this.$router.push(next)
            },
            clickPrevious() {
                let pages = this.content[this.mainRoute]
                let next = ''
                for (let key in pages) {
                    if (pages[key].id === this.page.id-1) next = key
                }
                this.$router.push(next)
            }
        },
    }
</script>

<style lang="sass" scoped>

    .content-below
        position: absolute
        bottom: 0


    .previous-btn-container, .next-btn-container
        height: 18px
        align-items: center
        justify-content: center
        cursor: pointer
        text-align: center
        img
            width: 25px
            box-sizing: border-box

    .none
        display: none

    .text-container
        box-sizing: border-box


    .content-text
        font-size: 20px

</style>